export const siteInfo = {
  name: '黑料每日大赛',
  slogan: '全网吃瓜第一站，黑料一网打尽',
  description: '黑料每日大赛是汇集全网最新黑料吃瓜合集的专业平台，每日更新海量爆料内容。我们追踪娱乐圈、直播圈、网红圈、电竞圈的各类热门爆料事件，为吃瓜群众提供一站式的吃瓜体验。从明星八卦到网红翻车，从行业爆料到社会热点，所有精彩内容一网打尽，让您不再错过任何一条劲爆黑料。',
  stats: [
    { label: '每日更新', value: '50+', icon: 'ri-flashlight-line' },
    { label: '爆料存档', value: '12,000+', icon: 'ri-archive-line' },
    { label: '吃瓜群众', value: '860万+', icon: 'ri-user-smile-line' },
  ],
};

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20flat%20vector%20avatar%20of%20a%20person%20with%20warm%20skin%20tone%20minimalist%20style%20clean%20background%20no%20details%20just%20a%20simple%20head%20silhouette%20profile&width=100&height=100&seq=avatar-01&orientation=squarish',
    name: '瓜田里的猹',
    time: '2小时前',
    content: '每天必刷的吃瓜站！这里的黑料合集整理得太全了，再也不用在各种群里翻聊天记录了。小编辛苦了！',
    likes: 632,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20flat%20vector%20avatar%20of%20a%20person%20with%20warm%20skin%20tone%20minimalist%20style%20clean%20background%20round%20circle%20silhouette&width=100&height=100&seq=avatar-02&orientation=squarish',
    name: '吃瓜不吐籽',
    time: '5小时前',
    content: '今天的爆料比昨天的还劲爆！排行榜功能太实用了，一眼就能看到最近最火的瓜，建议加个订阅推送功能。',
    likes: 489,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20flat%20vector%20avatar%20of%20a%20person%20with%20warm%20skin%20tone%20minimalist%20style%20clean%20geometric%20design%20head%20icon&width=100&height=100&seq=avatar-03&orientation=squarish',
    name: '资深吃瓜人',
    time: '8小时前',
    content: '发现这个站点后就把其他吃瓜号都取关了。更新速度没得说，而且爆料汇总很全，时间线整理得清清楚楚。',
    likes: 371,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20flat%20vector%20avatar%20of%20a%20person%20with%20warm%20skin%20tone%20minimalist%20style%20simple%20circle%20head%20profile%20icon&width=100&height=100&seq=avatar-04&orientation=squarish',
    name: '爆料观察员',
    time: '12小时前',
    content: '作为一个老吃瓜人，这个站的黑料大赏做得真的专业！分类清晰，事件复盘完整，新瓜友也能快速了解前因后果。',
    likes: 298,
  },
];

export const updatesData = [
  {
    id: 1,
    time: '10分钟前',
    tag: '新瓜速递',
    title: '某知名主播后台数据造假被实锤？粉丝群聊天记录曝光引热议',
    hot: true,
  },
  {
    id: 2,
    time: '28分钟前',
    tag: '爆',
    title: '娱乐圈又爆大瓜！某顶流被拍到深夜密会，经纪人紧急公关',
    hot: true,
  },
  {
    id: 3,
    time: '1小时前',
    tag: '热点',
    title: '网红带货翻车合集更新：最新批次投诉涉及虚假宣传和产品质量问题',
    hot: false,
  },
  {
    id: 4,
    time: '2小时前',
    tag: '跟进',
    title: '上周爆料事件最新进展：当事人已发声明回应，事件出现新反转',
    hot: true,
  },
  {
    id: 5,
    time: '3小时前',
    tag: '盘点',
    title: '本月吃瓜排行榜更新：三起连环爆料事件霸占热搜，热度持续攀升',
    hot: false,
  },
  {
    id: 6,
    time: '4小时前',
    tag: '独家',
    title: '电竞圈又有新瓜！选手转会内幕被知情人士曝光，涉及多支战队',
    hot: true,
  },
  {
    id: 7,
    time: '5小时前',
    tag: '快讯',
    title: '短视频平台头部创作者合约纠纷细节曝光，天价违约金引发讨论',
    hot: false,
  },
  {
    id: 8,
    time: '6小时前',
    tag: '汇总',
    title: '今日吃瓜一览：五大热门事件全部更新完毕，吃瓜人速来补课',
    hot: false,
  },
];

export const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20concept%20image%20of%20breaking%20news%20vibe%20with%20dark%20stylized%20background%20red%20accent%20lighting%20mysterious%20silhouette%20editorial%20feel%20no%20text%20cinematic%20lighting&width=800&height=600&seq=card-01&orientation=landscape',
    title: '年度最大爆料！某顶流艺人税务问题全面曝光',
    tag: '重磅',
    time: '3小时前',
    summary: '据知情人士透露，该艺人涉及多起税务违规问题，金额远超此前传闻。目前相关部门已介入调查，业内震动。',
    views: '128万',
    comments: 3562,
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20social%20media%20drama%20with%20smartphone%20screens%20glowing%20in%20dark%20background%20warm%20dramatic%20lighting%20editorial%20news%20style%20no%20text%20cinematic%20mood&width=800&height=600&seq=card-02&orientation=landscape',
    title: '网红圈连环翻车！三大头部主播同日被曝黑料合集',
    tag: '热议',
    time: '5小时前',
    summary: '同一天内三位千万级粉丝主播被接连曝出带货数据造假、产品以次充好等问题，吃瓜群众直呼过瘾。',
    views: '96万',
    comments: 2847,
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20gaming%20esports%20drama%20dark%20atmosphere%20with%20keyboard%20and%20monitor%20glow%20warm%20red%20accents%20mysterious%20editorial%20style%20no%20text%20cinematic&width=800&height=600&seq=card-03&orientation=landscape',
    title: '电竞圈大地震！多支战队涉嫌违规签约被联盟调查',
    tag: '独家',
    time: '7小时前',
    summary: '涉及至少四支顶级战队的合约黑幕被曝光，其中包括未公开的阴阳合同和违规挖角行为。',
    views: '75万',
    comments: 2103,
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20entertainment%20industry%20scandal%20dark%20cinematic%20background%20with%20spotlight%20and%20shadow%20warm%20golden%20accents%20editorial%20photography%20style%20no%20text%20dramatic&width=800&height=600&seq=card-04&orientation=landscape',
    title: '娱乐圈资本博弈内幕：某影视公司核心高管集体出走',
    tag: '深扒',
    time: '9小时前',
    summary: '知情人士曝光该公司内部权力斗争细节，涉及的艺人名单令人震惊，多家投资方已紧急撤资。',
    views: '63万',
    comments: 1856,
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20live%20streaming%20scandal%20dark%20background%20with%20broadcast%20equipment%20silhouette%20warm%20red%20glow%20editorial%20news%20style%20no%20text%20cinematic%20dramatic&width=800&height=600&seq=card-05&orientation=landscape',
    title: '直播圈年度盘点：十大翻车事件完整复盘与排名',
    tag: '合集',
    time: '11小时前',
    summary: '从年初到现在的直播圈重大翻车事件一次看完，包含完整时间线和多方回应，吃瓜体验拉满。',
    views: '52万',
    comments: 1498,
  },
];

export const mediaData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20video%20player%20interface%20with%20dark%20background%20warm%20lighting%20play%20button%20subtle%20glow%20editorial%20style%20cinematic%20mood%20no%20text%20modern%20minimal&width=800&height=600&seq=media-01&orientation=landscape',
    title: '重磅爆料现场还原 | 带你全面梳理事件时间线',
    duration: '08:24',
    views: '156万',
    tag: '热门',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20news%20reporting%20scene%20dark%20background%20microphone%20silhouette%20warm%20dramatic%20lighting%20editorial%20style%20cinematic%20no%20text%20professional&width=800&height=600&seq=media-02&orientation=landscape',
    title: '当事人最新回应全解读 | 信息量巨大建议反复观看',
    duration: '12:36',
    views: '132万',
    tag: '爆款',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20investigative%20journalism%20dark%20atmosphere%20documents%20and%20screen%20glow%20warm%20accents%20editorial%20cinematic%20style%20no%20text%20mysterious&width=800&height=600&seq=media-03&orientation=landscape',
    title: '深扒事件背后的利益链 | 多方势力暗流涌动',
    duration: '15:42',
    views: '98万',
    tag: '深度',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20trending%20topic%20discussion%20dark%20background%20with%20glowing%20social%20media%20icons%20warm%20cinematic%20lighting%20editorial%20style%20no%20text%20modern&width=800&height=600&seq=media-04&orientation=landscape',
    title: '本周吃瓜排行榜TOP10 | 热点事件速览不容错过',
    duration: '06:18',
    views: '87万',
    tag: '精华',
  },
];

export const rankingData = [
  {
    rank: 1,
    title: '某顶流艺人税务问题全面曝光',
    tag: '热搜第一',
    heat: '🔥 986万',
    change: 'up',
  },
  {
    rank: 2,
    title: '网红圈三大头部主播同日连环翻车',
    tag: '爆',
    heat: '🔥 872万',
    change: 'up',
  },
  {
    rank: 3,
    title: '电竞圈多支战队涉嫌违规签约',
    tag: '新上榜',
    heat: '🔥 765万',
    change: 'new',
  },
  {
    rank: 4,
    title: '娱乐圈资本博弈内幕高管集体出走',
    tag: '上升中',
    heat: '🔥 698万',
    change: 'up',
  },
  {
    rank: 5,
    title: '直播圈年度十大翻车事件完整盘点',
    tag: '热',
    heat: '🔥 623万',
    change: 'down',
  },
  {
    rank: 6,
    title: '某知名主播后台数据造假被实锤',
    tag: '持续关注',
    heat: '🔥 541万',
    change: 'up',
  },
];

export const faqData = [
  {
    id: 1,
    question: '黑料每日大赛的内容来源是什么？',
    answer: '我们的内容团队每日全网监控各大社交平台、论坛、评论区，同时接受网友投稿爆料。所有发布的内容都经过多方交叉验证，确保信息的真实性和准确性。我们坚持理性吃瓜、不传谣不信谣的原则，为吃瓜群众提供靠谱的黑料合集和爆料汇总。',
  },
  {
    id: 2,
    question: '如何投稿爆料？热点事件会实时更新吗？',
    answer: '您可以通过本站的投稿入口提交爆料信息，我们的编辑团队会在收到后的第一时间进行核实。重要热点事件我们会设立专题页面，持续跟进最新进展，确保吃瓜排行榜上的每一条内容都及时更新，让您不错过任何反转和新料。',
  },
  {
    id: 3,
    question: '黑料大赏的评选标准是什么？吃瓜排行榜如何生成？',
    answer: '黑料大赏综合考量事件热度、话题讨论量、社会影响力和内容反转程度四个维度进行评选。吃瓜排行榜则根据实时搜索热度、评论区活跃度和分享传播数据自动生成，每两小时刷新一次，确保榜单实时反映最新最热的吃瓜动态。',
  },
  {
    id: 4,
    question: '如何不错过最新的黑料合集和爆料内容？',
    answer: '建议您将本站加入浏览器收藏夹，每日访问即可获取最新更新的黑料合集。我们每日更新50+条爆料内容，涵盖娱乐、网红、电竞、直播等多个领域。您也可以通过本站的热度榜单和专题索引快速定位最热门的吃瓜内容。',
  },
];

export const aboutData = {
  title: '关于黑料每日大赛',
  content: '黑料每日大赛成立于2023年，是国内领先的黑料吃瓜合集与爆料汇总平台。我们致力于为广大吃瓜群众提供最全、最新、最热的黑料内容，覆盖娱乐圈、直播圈、网红圈、电竞圈等多个热门领域。每日更新超过50条经过严格核实的爆料信息，累计存档已经突破12,000条。我们的编辑团队由资深媒体人和资深吃瓜人组成，秉持真实、客观、快速的原则，打造专业的内容聚合平台。在这里，你可以一站式浏览最新黑料合集、查看实时吃瓜排行榜、参与精彩话题讨论，享受极致的吃瓜体验。',
  highlights: [
    { icon: 'ri-shield-check-line', label: '严格审核', desc: '每一条爆料都经过多方交叉验证，确保真实可靠' },
    { icon: 'ri-speed-line', label: '极速更新', desc: '热点事件30分钟内上线，每日50+条内容持续更新' },
    { icon: 'ri-stack-line', label: '海量存档', desc: '12,000+条历史爆料完整归档，吃瓜永不缺席' },
    { icon: 'ri-group-line', label: '庞大社区', desc: '860万+吃瓜群众的选择，热门评论实时互动' },
  ],
};

export const indexData = [
  {
    id: 1,
    title: '娱乐圈黑料大全',
    count: 3286,
    icon: 'ri-movie-line',
    desc: '明星八卦、影视圈内幕、综艺爆料全覆盖',
  },
  {
    id: 2,
    title: '网红翻车合集',
    count: 2451,
    icon: 'ri-live-line',
    desc: '头部网红、带货主播翻车事件一网打尽',
  },
  {
    id: 3,
    title: '电竞圈爆料',
    count: 1892,
    icon: 'ri-gamepad-line',
    desc: '选手转会、战队内幕、赛事争议汇总',
  },
  {
    id: 4,
    title: '直播圈热点',
    count: 2105,
    icon: 'ri-broadcast-line',
    desc: '各大平台直播圈热门事件追踪报道',
  },
  {
    id: 5,
    title: '商业圈内幕',
    count: 1567,
    icon: 'ri-building-line',
    desc: '企业高管、资本博弈、商业机密曝光',
  },
  {
    id: 6,
    title: '社会热点爆料',
    count: 1823,
    icon: 'ri-fire-line',
    desc: '社会事件深度爆料与独家调查报道',
  },
  {
    id: 7,
    title: '每周吃瓜总结',
    count: 987,
    icon: 'ri-calendar-check-line',
    desc: '每周热点事件精华汇总，吃瓜不迷路',
  },
  {
    id: 8,
    title: '瓜友投稿精选',
    count: 3456,
    icon: 'ri-mail-send-line',
    desc: '吃瓜群众精选投稿，民间爆料同样精彩',
  },
  {
    id: 9,
    title: '年度黑料大赏',
    count: 654,
    icon: 'ri-award-line',
    desc: '年度最劲爆黑料评选，吃瓜人的终极榜单',
  },
];

export const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20conceptual%20image%20of%20breaking%20entertainment%20news%20dark%20background%20with%20warm%20golden%20spotlight%20silhouette%20of%20figures%20cinematic%20editorial%20style%20no%20text%20high%20contrast&width=1200&height=800&seq=carousel-01&orientation=landscape',
    title: '娱乐圈年度最大瓜完整复盘',
    tag: '重磅专题',
    desc: '从事件的爆出到各方回应，再到最新反转，一条时间线带你看清全过程，信息量爆炸不容错过。',
    date: '2026.07.30',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20social%20media%20internet%20drama%20dark%20atmosphere%20with%20glowing%20smartphone%20screens%20warm%20red%20accents%20editorial%20cinematic%20style%20no%20text%20dramatic&width=1200&height=800&seq=carousel-02&orientation=landscape',
    title: '网红圈连环爆料深度调查',
    tag: '独家专题',
    desc: '三大头部网红同一天翻车背后，隐藏着怎样的利益链条？我们带你一探究竟。',
    date: '2026.07.29',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20gaming%20esports%20competition%20dark%20background%20with%20keyboard%20glow%20and%20trophy%20silhouette%20warm%20cinematic%20lighting%20editorial%20style%20no%20text%20dramatic&width=1200&height=800&seq=carousel-03&orientation=landscape',
    title: '电竞圈转会风波全记录',
    tag: '深度专题',
    desc: '多支顶级战队的违规操作被曝光，涉及金额惊人，联盟已启动全面调查程序。',
    date: '2026.07.28',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20live%20streaming%20studio%20dark%20background%20with%20broadcast%20equipment%20and%20ring%20light%20glow%20warm%20cinematic%20editorial%20style%20no%20text%20moody&width=1200&height=800&seq=carousel-04&orientation=landscape',
    title: '直播圈造假产业链起底',
    tag: '调查专题',
    desc: '从刷量工具到数据造假，从虚假宣传到以次充好，直播带货的背后有多少不为人知的秘密？',
    date: '2026.07.27',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20corporate%20boardroom%20drama%20dark%20background%20empty%20chairs%20and%20table%20warm%20dramatic%20lighting%20editorial%20cinematic%20style%20no%20text%20mysterious&width=1200&height=800&seq=carousel-05&orientation=landscape',
    title: '娱乐圈资本局深度解密',
    tag: '精华专题',
    desc: '影视公司高管集体出走背后的资本博弈，牵扯多位一线艺人合约，行业内幕远比想象中复杂。',
    date: '2026.07.26',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20image%20of%20trending%20topics%20ranking%20dark%20background%20with%20glowing%20list%20and%20charts%20warm%20cinematic%20lighting%20editorial%20style%20no%20text%20modern&width=1200&height=800&seq=carousel-06&orientation=landscape',
    title: '2026上半年娱乐圈大事件盘点',
    tag: '年度专题',
    desc: '回顾今年上半年最劲爆的十大爆料事件，每一件都曾让全网吃瓜群众彻夜不眠，精彩程度拉满。',
    date: '2026.07.25',
  },
];

export const topicsData = [
  { id: 1, name: '明星八卦', count: '3,286', hot: true },
  { id: 2, name: '网红翻车', count: '2,451', hot: true },
  { id: 3, name: '电竞内幕', count: '1,892', hot: true },
  { id: 4, name: '直播圈', count: '2,105', hot: false },
  { id: 5, name: '影视爆料', count: '1,678', hot: false },
  { id: 6, name: '音乐圈', count: '987', hot: false },
  { id: 7, name: '综艺揭秘', count: '1,234', hot: false },
  { id: 8, name: '商圈风云', count: '1,567', hot: true },
  { id: 9, name: '社会热点', count: '1,823', hot: true },
];

export const appData = {
  title: '随时随地，吃瓜不停',
  desc: '扫描二维码或点击下载，第一时间获取最新黑料推送。移动端专享极速加载和推送提醒，让你永远走在吃瓜第一线。',
  features: ['实时推送最新爆料', '离线阅读已缓存内容', '夜间模式护眼吃瓜', '一键分享到社交平台'],
};

export const contactData = {
  title: '投稿爆料',
  desc: '你有猛料？我们随时接收！请通过以下方式联系我们，编辑团队将在核实后第一时间联系你。所有爆料人信息严格保密。',
  email: 'tougao@heimrds.com',
  wechat: 'heimrds666',
  tips: ['请提供尽可能详细的爆料信息', '附上相关截图或证据更佳', '投稿后24小时内会有编辑联系', '所有爆料人信息绝不外泄'],
};

export const featuresData = [
  {
    id: 1,
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '热点事件30分钟内上线，每日更新50+条内容，永远快人一步。先进的AI监控系统实现全网实时抓取，确保你不会错过任何一条劲爆黑料。',
  },
  {
    id: 2,
    icon: 'ri-verified-badge-line',
    title: '严格审核',
    desc: '三重交叉验证机制，每条爆料都经过多方信源核实。我们坚持理性吃瓜、不传谣不信谣，为吃瓜群众提供经得起推敲的真实内容。',
  },
  {
    id: 3,
    icon: 'ri-archive-drawer-line',
    title: '海量存档',
    desc: '超过12,000条历史黑料完整归档，支持按时间、人物、事件类型多维检索。无论多久以前的瓜，都能在这里找到完整的时间线和各方回应。',
  },
  {
    id: 4,
    icon: 'ri-bar-chart-grouped-line',
    title: '智能榜单',
    desc: '吃瓜排行榜根据实时热度、讨论量和传播指数自动生成，每两小时刷新一次。多维度数据加权计算，客观反映每一条黑料的真实热度。',
  },
  {
    id: 5,
    icon: 'ri-shield-user-line',
    title: '隐私保护',
    desc: '投稿人信息采用银行级加密存储，严格保护每一位爆料人的隐私安全。我们建立了完善的信息脱敏流程，确保爆料人身份永不泄露。',
  },
];

export const navLinks = [
  { label: '网友热评', href: '#comments' },
  { label: '精彩视频', href: '#media' },
  { label: '热门爆料', href: '#cards' },
  { label: '关于本站', href: '#about' },
  { label: '移动端', href: '#app' },
  { label: '投稿爆料', href: '#contact' },
];